import React from "react";
import { services, images } from "../mock";
import { ArrowRight } from "lucide-react";

const Services = () => {
  return (
    <section id="services" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${images.hero})` }}
      />
      <div className="absolute inset-0 service-bg-overlay" />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <h2 className="font-display text-white text-center text-4xl md:text-5xl font-bold tracking-wide">
          OUR <span className="text-[color:var(--brand-teal-light)]">SERVICES</span>
        </h2>
        <div className="h-1 w-20 bg-[color:var(--brand-red)] mx-auto mt-4 mb-14" />

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((s) => (
            <div
              key={s.id}
              className="service-card bg-transparent border-2 border-white/60 rounded-md overflow-hidden p-5"
            >
              <div className="overflow-hidden rounded-sm">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-56 object-cover transform hover:scale-105 transition-transform duration-700"
                />
              </div>
              <h3 className="font-display text-white text-xl font-bold mt-6 leading-snug">
                {s.title}
              </h3>
              <p className="text-white/85 mt-3 leading-relaxed text-sm">{s.description}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-12">
          <a
            href="#contact"
            className="btn-red font-display uppercase tracking-wider px-10 py-3 rounded text-sm inline-flex items-center gap-2"
          >
            See All <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
